import config from "../Config/config";

const fetchStatuses = async (setStatus) => {
  try {
    const response = await fetch(`${config.serverBaseUrl}/status`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
    });
    const resJson = await response.json();
    const data = resJson.data;
    setStatus(data.statuses);
  } catch (error) {
    console.error(`Failed to fetch statuses: ${error}`);
  }
};

export { fetchStatuses };
